import ApiService from './api.service.js'

const OppregAdminService = {
  initOppregData: async function () {
    try {
      let oppregReqParams = {
        params: {
          action: 'oppreg-admin-custom-view'
        }
      }
      let oppregProjectResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregReqParams)
      return oppregProjectResponse.data
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  refreshData: async function () {
    return this.initOppregData()
  },

  getWorkloadsBySalesForceId: async function (id, callback) {
    try {
      let oppregParams = {
        params: {
          action: 'oppreg-project',
          SFDC_Id: id
        }
      }
      let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregParams)
      callback(oppregResponse.data)
    } catch (error) {
      vm.$store.commit('setWorkloadLoading', false)
    }
  },

  getChangeLogsById: async function (id, callback) {
    try {
      let logsParams = {
        params: {
          action: 'change-log',
          Record_Id: id
        }
      }
      let logsResponse = await ApiService.get(process.env.VUE_APP_CHANGE_LOG_API, logsParams)
      callback(logsResponse.data)
    } catch (error) {
      vm.$store.commit('setLoadingLogs', false)
    }
  },

  createAwsInfoLog: async function (recordId, changeFrom, changeTo, callback) {
    try {
      let logReqBody = {
        action: 'change-log',
        Action: changeFrom === null ? 'add' : 'update',
        Change_From: JSON.stringify(changeFrom, undefined, 2),
        Change_To: JSON.stringify(changeTo, undefined, 2),
        Record_Id: recordId,
        User: vm.$store.state.currentUser.name
      }
      let logPostRes = await ApiService.post(process.env.VUE_APP_CHANGE_LOG_API, logReqBody)
      callback(logPostRes.data)
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  getWorkloadsByProjectId: async function (id, callback) {
    try {
      
      let responses = {}
      let oppregParams = {
        params: {
          action: 'Workloads-by-project-id',
          Project_Id: id
        }
      }
      let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregParams)
      responses = oppregResponse.data[0]
      callback(responses)
    
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  oppnumUpdate: async function (data, callback) {
    try {
      // let OpportunityNumber
      // let getParams = {
      //   params: {
      //     action: 'Workloads-by-project-id',
      //     Project_Id: vm.$route.params.id,
      //   }
      // }
      // let oppPostres = await ApiService.get(process.env.VUE_APP_OPPREG_API, getParams)
      // ProjID = oppPostres.data.Project_Id
      // console.log('Opportunity_Number: ' + ProjID)
      let qParams = {
        action: 'Workloads-by-project-id',
        Opportunity_Id: data['opportunity'].Opportunity_Id,
        Opportunity_Number: data['opportunity'].Opportunity_Number
      }
      console.log(qParams)
      let oppPutRes = await ApiService.put(process.env.VUE_APP_OPPREG_API, qParams)
      callback(oppPutRes.data)
      // if (oppPutRes.data) {
      //   callback(oppPutRes)
      // }
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  workloadSave: async function (data, callback) {
    try {
      let awsInfoId
      let awsGetParams = {
        params: {
          action: 'check-aws-info',
          Project_Id: vm.$route.params.id,
          AWS_Date_Approved: data['aws'].AWS_Date_Approved,
          AWS_SalesRep_Name: data['aws'].AWS_SalesRep_Name,
          AWS_SalesRep_eMail: data['aws'].AWS_SalesRep_eMail,
          OppReg_Status: data['aws'].OppReg_Status,
          AWS_Notes: data['aws'].AWS_Notes,
          Non_DXC_Account_No: data['aws'].Non_DXC_Account_No,
          Non_DXC_Launch_Date: data['aws'].Non_DXC_Launch_Date,
          DXC_Account_No: data['aws'].DXC_Account_No,
          DXC_Launch_Date: data['aws'].DXC_Launch_Date
        }
      }
      let awsPostRes = await ApiService.get(process.env.VUE_APP_OPPREG_API, awsGetParams)
      awsInfoId = awsPostRes.data.AWSInfo_id
      console.log('awsInfoID: '+ awsInfoId)

      if (awsInfoId) {
        console.log('Workload Status: '+ data.aws.OppReg_Status)
        let oppregParams = {
          action: 'oppreg-project',
          Registration_Id: data['questionaire'].Registration_Id,
          Workload_Status: data['aws'].OppReg_Status,
          Closed_Ind: 'N'
        }

        if(data.aws.OppReg_Status === 'OppReg Closed') {
          oppregParams.Closed_Ind = 'Y'
        }
           
        console.log(oppregParams)
        let oppregPutRes = await ApiService.put(process.env.VUE_APP_OPPREG_API, oppregParams)
        if (oppregPutRes.data) {
          callback(awsInfoId)
        }
      }
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  updateQuestionnaire: async function (data, callback) {
    try {
      let oppregParams = {
        action: 'oppreg-project',
        Registration_Id: data.id,
        Workload_type: data.type,
        Campaign_Name: data.answers.Campaign_Name,
        Solution_Business_Segment: data.answers.Solution_Business_Segment,
        Is_Glacier: data.answers.Is_Glacier,
        Workload_Title: data.answers.Workload_Title,
        Q1: data.answers.Q1,
        Q2: data.answers.Q2,
        Q3: data.answers.Q3,
        Q4: data.answers.Q4,
        Q5: data.answers.Q5,
        Q6: data.answers.Q6,
        Q7: data.answers.Q7,
        Q8: data.answers.Q8,
        Q9: data.answers.Q9,
        Q10: data.answers.Q10,
        Attested_By_Date: data.answers.Attested_By_Date,
        Attested_By_Email: data.answers.Attested_By_Email,
        Attested_By_Title: data.answers.Attested_By_Title,
        Attested_By_Manager: data.answers.Attested_By_Manager,
        Attested_By_Date_2: data.answers.Attested_By_Date_2,
        Attested_By_Email_2: data.answers.Attested_By_Email_2,
        Attested_By_Title_2: data.answers.Attested_By_Title_2,
        Attested_By_Manager_2: data.answers.Attested_By_Manager_2,
        // Discount_Tier_On_AWS: data.answers.Discount_Tier_On_AWS,
        Discount_Tier_On_AWS: data.answers.Discount_Tier_On_AWS,
        Discount_Tier_On_AWS_2: data.answers.Discount_Tier_On_AWS_2,
        Pricing_Tier_Qualification: data.answers.Pricing_Tier_Qualification,
        Pricing_Tier_Qualification_2: data.answers.Pricing_Tier_Qualification_2
      }

      if (data.answers.Scope_of_Work !== 'None' && data.answers.Campaign_Name.includes('Glacier')) {
        oppregParams['Scope_of_Work'] = data.answers.Scope_of_Work
      }
      let oppregPutRes = await ApiService.put(process.env.VUE_APP_OPPREG_API, oppregParams)
      if (oppregPutRes.data) {
        callback(oppregWorkloadAnswerBodyResponse.data.id)
      }
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
    
  },

  sendChangeWorkloadNotification: async function(data, callback) {
    try {
      let reqData = {
        action: 'external',
        send_to: 'kcabading2@dxc.com',
        template: 'workload-type-change',
        from: data.fromWorkloadType,
        to: data.toWorkloadType,
        oppreg_id: data.id
      }
      let res = await ApiService.post(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, reqData)
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  saveNewCustomer: async function (data, callback) {
    try {
      let custGetParams = {
          action: 'customer-region',
          ...data
      }
      let custGetResponse = await ApiService.post(process.env.VUE_APP_CUSTOMER_REGIONS_API, custGetParams)
        callback(null, { message: custGetResponse.data.response })
    } catch (error) {
      vm.$store.commit('setNewCustomerSaving', false)
      callback(null, { error: 'Error saving new customer' })
    }
  },

  getOnboardingRequest: async function (callback) {
    try {
      let reqParams = {
        params: {
          action: 'onboard-aws-account-requests'
        }
      }
      let requests = await ApiService.get(process.env.VUE_APP_AWS_ACCOUNT_ONBOARDING, reqParams)
      if (requests.data.length) {
        callback(requests.data)
      } else {
        callback(null, { error: 'No Records Found' })
      }
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  updateOnboardingRequests:async function(requests, callback){
    try{
        console.log('--------service:updateOnboardingRequests---------')
        console.log(requests)
        requests.forEach(async function ( request, index) {
          console.log(index); // index
          console.log(request); // value
          let onboardingReqParams = {
            action: 'onboarding-header',
            Onboarding_Id: request.Onboarding_Id,
            Onboarding_Status: request.Onboarding_Status,
            Acct_name:request.Acct_name
          }
          console.log('----- onboardingParams -------')
          console.log(onboardingReqParams)

          let onboardingReqResponse = await ApiService.put(process.env.VUE_APP_REQUEST_AWS_ACCOUNT,onboardingReqParams)
          console.log(onboardingReqResponse)
          if (onboardingReqResponse.data) {
           callback(onboardingReqResponse.data)
         } else {
           callback(null, { error: 'Error creating onboarding account' })
         }
        });
    } catch(error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  updateCustomer: async function (data, callback) {
    try {
      delete data['Cust_Region']
      let customerParams = {
        action: 'customer-region',
        ...data
      }
      let customerResponse = await ApiService.put(process.env.VUE_APP_CUSTOMER_REGIONS_API, customerParams)
      if (!customerResponse.data) {
        callback(null, { message: 'Error updating customer' })
      } else {
        let response = { id: customerResponse.data.id, message: 'Successfully updated Customer' }
        callback(response)
      }
    } catch (error) {
      vm.$store.commit('setNewCustomerSaving', false)
    }
  },

  getCustomers: async function (callback) {
    try {
      let custGetParams = {
        params: {
          action: 'customer-region'
        }
      }
      let custGetResponse = await ApiService.get(process.env.VUE_APP_CUSTOMER_REGIONS_API, custGetParams)

      if (callback === undefined) return custGetResponse.data
      if (!custGetResponse.data.length) {
        callback(null, { message: 'No Customers Found' })
      }
      callback(custGetResponse.data)
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },
  
  getWorkloadsByOppId: async function (opportunityId, callback) {
    try {
      const oppFound = await this.findOpportunityById(opportunityId)
      if (!oppFound) {
        let reqSfParams = {
          params: {
            client_ID: opportunityId
          }
        }
        let sfResponse = await ApiService.get(process.env.VUE_APP_SALESFORCE_REGISTER_API, reqSfParams)
        if (sfResponse.data === null) {
          callback(null, { opportunityFound: false, message: 'Invalid Opportunity Id' })
        } else {
          callback(null, { opportunityFound: true })
        }
      } else {
        let projectParams = {
          params: {
            get_records: 'list',
            SFDC_Id: opportunityId
          }
        }
        let oppregResponse = await ApiService.get(process.env.VUE_APP_WORKLOAD_API, projectParams)
        if (oppregResponse.data.length) {
          // eslint-disable-next-line standard/no-callback-literal
          callback({ id: opportunityId, workloads: oppregResponse.data })
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          callback({ noWorkloadsFound: true, id: opportunityId, message: 'No workloads has been registered yet for this opportunity.' })
        }
      }
    } catch (error) {
      vm.$store.commit('setLoadingWorkloads', false)
    }
  },
  
  // OPPREG ADMIN: UPLOAD DOCUMENT
  uploadDocument: async function (params, callback) {
    try {
      params.filename = params.filename.replace(/\s/g, '-')
      let object_key = params.filename
      let ContentType = params.FileType
      
      if (ContentType == null || ContentType == "") { 
        ContentType = "text/html"
        if (object_key.split('.').pop() == "msg") {
          ContentType = "application/vnd.ms-outlook"
        }
      }

      let request_params = {params: {
          name: object_key, method: 'put_object', contenttype: ContentType
        }}
      
      let response = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, request_params)
      let presigned_url = response.data

      let upload = { Key: params.filename, ContentType: ContentType, file: params.File }
      let UploadResponse = await ApiService.put(presigned_url, upload)
      
      let responses = { docResponse: null, reloadResponse: null }

      let docRepoParams = {
        action: 'document-repository',
        AWS_Info_Id: params.AWS_Info_Id,
        FileName: params.filename,
        Uploaded_By: params.uploadedBy
      }
      let docResponse = await ApiService.post(process.env.VUE_APP_OPPREG_API, docRepoParams)
      responses.docResponse = docResponse.data

      let reloadParams = {
        params: { action: 'document-repository', AWS_Info_Id: params.AWS_Info_Id }
      }
      let reloadResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, reloadParams)
      responses.reloadResponse = reloadResponse.data
      callback(responses)

    } catch (error) {
      vm.$store.commit('setUploadingState', false)
    }
    
  
  },

  // OPPREG ADMIN: DOWNLOAD DOCUMENT
  downloadDocument: async function (object_name, callback) {
    let request_params = { params: { name: object_name } }
    let presigned_url = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, request_params)
    callback(presigned_url.data)
  },

  // GENERAL REPORTING
  retrieveOppRegRequests: async function (params, callback) {
    let requestParams = {
      params: {
        Opportunity_Id: params['sfdcId'],
        Customer_Name: params['Customer_Name'],
        ESRegion: params['ESRegion'],
        Workload_Status: params['Workload_Status'],
        action: params['action'],
        from_date: params['from_date'],
        to_date: params['to_date'],
        Global_Registered: params['Global_Registered'],
        Campaign_Name: params['Campaign_Name']
      }
    }
    if (params.size) {
      requestParams.params.size = params.size
    }
    if (params.nextPageKey) {
      requestParams.params.nextPageKey = params.nextPageKey
    }
    if (params['AWS_ACE_ID']) {
      requestParams.params.AWS_ACE_ID = params['AWS_ACE_ID']
    }
    if (params['report_type']) {
      requestParams.params.report_type = params['report_type']
    }
    if (params['Requestor_Email']) {
      requestParams.params.Requestor_Email = params['Requestor_Email']
    }
    if (vm.$store.state.currentUser.routes[0].fieldPermissions['report-filter-regions']) {
      if (!params['ESRegion']) {
        requestParams.params.ESRegion = vm.$store.state.currentUser.routes[0].fieldPermissions['report-filter-regions'].toString()
      } else {
        // requestParams.params.ESRegion = vm.$store.state.currentUser.routes[0].fieldPermissions['report-filter-regions'].toString() + ',' + params['ESRegion']
        requestParams.params.ESRegion = params['ESRegion']
      }
    }
    console.log('requestParams', requestParams)
    try {
      let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_REQUEST_API, requestParams)
      if (params['action']) {
        callback(oppregResponse.data)
      } else {
        callback({ OppRegRequestsData: oppregResponse.data })
      }

    } catch (error) {
      vm.$store.commit('showWorkloadSearching', { searching: false })
    }
  },

  retrieveEmailAuditTrail: async function (params, callback) {
    let requestParams = { params: params }
    try {
      let resultset = await ApiService.get(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, requestParams)
      callback({ EmailAuditData: resultset.data })
    } catch (error) {
      vm.$store.commit('setLoadingResponse', false)
    }
  },

  submitOpportunityDataToAPN: async function (workloads, callback) {
    // let responses = 'Inbound Opportunity submitted to AWS Partner Network.'
    let uniqueKey = identifier => identifier.partnerCrmUniqueIdentifier
    let toHashMap = (data, ukey) => data.reduce((data, item) => (data[ukey(item)] = item, data), {})
    let hashMap = JSON.stringify(toHashMap(workloads, uniqueKey))

    let opportunity = { action: 'inbound-opportunity', data: hashMap }
    let response = await ApiService.post(process.env.VUE_APP_AWS_PARTNER_NETWORK, opportunity)
    callback(response)
  },

  validateContactEmail: async function (contact, callback) {

    // Contact Params: ID  = Contact_Id
    let contactParams = {
      params: {
        action: 'contact-info',
        Contact_Email: contact.Contact_Email
      }
    }
    let contactGetResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, contactParams)
    if (contactGetResponse.data.length) {
      callback(contactGetResponse.data[0])
    } else {
      callback(null, { error: true })
    }
  },

  updateContact: async function (contact, callback) {
    let { Contact_FullName, ...contactFields } = contact

    // set body
    let contactBody = {
      action: 'contact-info',
      ...contactFields
    }
    let contactResponse = await ApiService.put(process.env.VUE_APP_OPPREG_API, contactBody)
    if (contactResponse.data) {
      callback(contactResponse.data)
    } else {
      callback(null, { error: 'Error Validating Email' })
    }
  },


  updateOpportunity: async function (opportunity, callback) {

    let {
      Opportunity_Id,
      SFDC_Oppty_Name,
      SFDC_Sales_Stage, 
      SignDate, 
      OpportunityTotalValueUSD, 
      ESRegion, 
      Country, 
      PrimaryESPracticeName,
      OpportunityDescription,
      OpportunityStatus,
      IndustryVertical,
      ContractLength,
      AWS_ACE_ID,
      Owner_Email,
      Owner_Name,
      Global_Registered,
      Is_Archived
    } = opportunity

    // set body
    let oppBody = {
      action: 'oppreg-info',
      Opportunity_Id, 
      SFDC_Oppty_Name,
      SFDC_Sales_Stage, 
      SignDate, 
      OpportunityTotalValueUSD, 
      ESRegion, 
      Country, 
      PrimaryESPracticeName,
      OpportunityDescription,
      OpportunityStatus,
      IndustryVertical,
      ContractLength,
      AWS_ACE_ID,
      Owner_Email,
      Owner_Name,
      Global_Registered,
      Is_Archived
    }
    let contactResponse = await ApiService.put(process.env.VUE_APP_OPPREG_API, oppBody)
    if (contactResponse.data) {
      callback(contactResponse.data)
    } else {
      callback(null, { error: 'Error Updating Opportunity' })
    }

  },

  updateProjectContact: async function (data, callback) {
    let oppregParams = {
      action: 'oppreg-project',
      Registration_Id: data.Registration_Id,
      Contact_Id: data.Contact_Id
    }
    let oppregPutRes = await ApiService.put(process.env.VUE_APP_OPPREG_API, oppregParams)
    if (oppregPutRes.data) {
      callback(oppregPutRes.data)
    } else {
      callback(null, { error: 'Error Updating Project Contact' })
    }
  },
  updateAccount: async function (account, callback) {
    console.log('updateAccount', account)
    let accountBody = {
      action: 'account-info',
      ...account
    }
    console.log('accountBody', accountBody)

    let accountResponse = await ApiService.put(process.env.VUE_APP_OPPREG_API, accountBody)
    if (accountResponse.data) {
      callback(accountResponse.data)
    } else {
      callback(null, { error: 'Error Updating Opportunity' })
    }
  },
  getArchive: async function (params) {
    try {
      let oppregReqParams = {
        params: {
          action: 'archived-list',
          size: params.size
        }
      }
      if (params.Opportunity_Id) {
        oppregReqParams.params.Opportunity_Id = params.Opportunity_Id
      }
      if (params.nextArchivedPageKey) {
        oppregReqParams.params.nextPageKey = params.nextArchivedPageKey
      }
      if (params.searchAll) {
        oppregReqParams.params.searchAll = params.searchAll
      }
      let oppregProjectResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregReqParams)
      // return oppregProjectResponse.data
      return {
        data: oppregProjectResponse.data.oppreg_data.data,
        nextPageKey: oppregProjectResponse.data.oppreg_data.next_data
      }
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },
  archiveOppreg: async function (data) {
    console.log('oppregadmin.services')
    try {
      let oppregReqParams = {
        params: {
          action: 'archive-oppreg',
          opp_id: data.opp_id,
          is_archive: data.archive
        }
      }
      
      let oppregProjectResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregReqParams)
      return oppregProjectResponse.data
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },
  listAdminOppreg: async function (data) {
    console.log('listAdminOppreg', data)
    try {
      const page_size = data.size ? data.size : '10'
      let oppregReqParams = {
        params: {
          action: 'oppreg-admin-custom-view',
          size: page_size
        }
      }
      if (data.nextPageKey) {
        oppregReqParams.params.nextPageKey = data.nextPageKey
      }
      if (data.Opportunity_Id) {
        oppregReqParams.params.Opportunity_Id = data.Opportunity_Id
      }
      if (data.searchAll) {
        oppregReqParams.params.searchAll = data.searchAll
      }
      let oppregProjectResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregReqParams)
      console.log('oppregProjectResponse', oppregProjectResponse)
      // return { data: oppregProjectResponse.data, nextPageKey: oppregProjectResponse.next_key }
      return { data: oppregProjectResponse.data.oppreg_data.data, nextPageKey: oppregProjectResponse.data.oppreg_data.next_data }
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  }
}

export default OppregAdminService
